export default __webpack_public_path__ + "5fc00680130a38b52342270f3f93bdb0.png";